const parntershipSection = $('#partnership-section')
const partnershipDescriptor = parntershipSection.find('.section-descriptor');
const parntershipDescriptorCards = parntershipSection.find('.descriptor-card')
const partnershipCards = parntershipSection.find('.partnership-card-parent')

const addElearningPartnershipAnimation = () => {
  const sectionTopperTL = gsap.timeline({ paused: true });
  const animationInConfig = {
    descriptor: {
        offsetPercent: 36.6,
        duration: 1,
    },
    descriptorCard: {
        offsetPercent: 36.6,
        duration: 1,
    },
    title: {
        offsetPercent: 200,
        opacityStart: 0,
        blurStart: '0px',
        duration: 1.2,
        delay: 0.3,
        stagger: 0.066,
        isDurationCommon: true,
    },
  };

  sectionTopperTL.add(
    animateSectionTopperIn({
      sectionParent: parntershipSection,
      titleStagger: 0.198,
      animationInConfig: animationInConfig,
    }).play(),
    0
  );

  sectionTopperTL.add(elementInAnimationYWOpacity(partnershipDescriptor, '36.6%', 0, 1, 1, 1, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.1);
  sectionTopperTL.add(elementInAnimationYWOpacity(parntershipDescriptorCards, '100%', 0, 1, 1, 1, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0.5);
  sectionTopperTL.add(elementInAnimationYWOpacity(partnershipCards, '50%', 0, 1, 1, 1, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0.7);

  return sectionTopperTL;
};

const initElearningPartnership = () => {

  if(isDesktop()){
    const elearningPartnershipTL = addElearningPartnershipAnimation();

    ScrollTrigger.create({
        trigger: parntershipSection,
        start: `top top+=70%`,
        end: 'top+=20% top',
        once: true,
        onEnter: () => {
        elearningPartnershipTL.play();
        },
    });
  }
}

addSectionObserver(parntershipSection, initElearningPartnership);
